var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.mu{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mu",
    d: "M6.57,9.07c0,0.85,0.41,1.28,1.24,1.28c0.56,0,0.96-0.15,1.22-0.46s0.39-0.81,0.39-1.5V5.58h0.81v5.35H9.57 l-0.13-0.72H9.4c-0.36,0.54-0.92,0.82-1.66,0.82c-0.49,0-0.88-0.15-1.16-0.45H6.53c0.03,0.27,0.05,0.67,0.05,1.19v1.56H5.76V5.58 h0.81V9.07z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMu);
export default __webpack_public_path__ + "static/media/icon_mu.6a5bf1c227029b2723df44eda3760b3d.svg";
export { ForwardRef as ReactComponent };